import { useAuth } from '@/auth'
import {
  MicrophonePermissionErrorDialog,
  MicrophonePermissionProvider
} from '@mote/recipes'
import { WebRecorder } from './WebRecorder'
import { WebRecorderUnauthenticatedLayout } from './WebRecorderUnauthenticatedLayout'

export function WebRecorderScreen() {
  const auth = useAuth()
  return (
    <MicrophonePermissionProvider>
      <WebRecorder
        isAnonymous={false}
        name={auth.getUser().name}
        avatarUrl={auth.getUser().avatarUrl}
        quotaResetsAt={auth.getUser().quotaResetsAt}
        isMinor={auth.getUser().isMinor}
      />
      <MicrophonePermissionErrorDialog />
    </MicrophonePermissionProvider>
  )
}

export function AnonymousWebRecorder() {
  return (
    <MicrophonePermissionProvider>
      <WebRecorderUnauthenticatedLayout>
        <WebRecorder isAnonymous={true} />
      </WebRecorderUnauthenticatedLayout>
    </MicrophonePermissionProvider>
  )
}
